/**
 * Direct Swap Page
 */
import AdblockChecker from '../../components/AdblockModal';
import Notifs from '../../components/Notifications';
import Modal from '../../components/Modal/index';
import Header from '../MainPage/Header';
import DSChart from './DSChart';
import { useLoaderData } from 'react-router-dom';

const DirectSwapPage = (props: any) => {
  const directSwaps = useLoaderData() as any;
  return (
    <div className='main_page' style={{ overflowX: 'hidden' }}>
      <Header />
      <DSChart data={directSwaps} />
      <Modal />
      <Notifs />
      <AdblockChecker />
    </div>
  );
};

export default DirectSwapPage;
